import TrackingStore from './store';
import TrackingActions from './actions';

export default TrackingActions;


// WEBPACK FOOTER //
// ./medscape_modules/tracking/index.js